import axios from "axios";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function SiteMap() {
  const [siteMap, setSiteMap] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSiteMapData = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/getCmsContent`,
        {
          post_url: "site-map",
        }
      );
      setSiteMap(res.data.data);
    } catch (err) {
      console.error("Error fetching cancellation policy:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // ya "auto"
    fetchSiteMapData();
  }, []);

  return (
    <section class="ser_v_araeea faqess">
      <SetMetaTags
        title={siteMap?.meta_title}
        description={siteMap?.meta_description}
        keywords={siteMap?.meta_keyword}
      />

      <div class="container">
        {loading ? (
          <Skeleton count={5} height={20} style={{ marginBottom: "10px" }} />
        ) : (
          siteMap?.content && (
            <div
              dangerouslySetInnerHTML={{
                __html: siteMap.content,
              }}
            />
          )
        )}
      </div>
    </section>
  );
}

export default SiteMap;
